/**
 * UI-6b Task 13 — RecentRecordings widget manifest.
 */
import { registerWidget } from '../registry.js'
import type { WidgetManifest } from '../types.js'
import {
  RecentRecordingsRenderer,
  type RecentRecordingsConfig,
} from './Renderer.js'
import { RecentRecordingsConfigEditor } from './ConfigEditor.js'

export const recentRecordingsManifest: WidgetManifest<RecentRecordingsConfig> = {
  type: 'recent-recordings',
  label: 'Recent Recordings',
  description: 'Top-N most recent call recordings from the last 24h.',
  defaultSize: '2x2',
  defaultConfig: { limit: 5 },
  Renderer: RecentRecordingsRenderer,
  ConfigEditor: RecentRecordingsConfigEditor,
}

registerWidget(recentRecordingsManifest)
